import React, { Component } from 'react';
import { graphql } from 'gatsby';
import { withStyles } from '@material-ui/styles';

import { postData } from './actions';
import Form from './Form';
import styles from './styles';

class CgbFormVacancySignUp extends Component {
  render() {
    const { classes, attributes, parentAttributes } = this.props;
    const classNames = `
      ${attributes.className ? attributes.className : ''}
      ${classes.FormVacancySignUp} ${classes.FormVacancySignUpTheme}
    `;

    return <section className={classNames}>
      <Form classes={classes} postData={postData} />
    </section>
  }
};

export const CgbFormVacancySignUpBlock = withStyles(styles)(CgbFormVacancySignUp);

export default CgbFormVacancySignUpBlock;

export const CgbFormVacancySignUpBlockFragment = graphql`
  fragment CgbFormVacancySignUpBlock on WpBlock {
    ... on WpCgbFormVacancySignUpBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbFormVacancySignUpBlockPreview = `
    ... on CgbFormVacancySignUpBlock {
        name
        attributes {
            className
        }
    }
`;
